/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../components/auth/auth-constants';
import {BlocklistResource} from '../../components/api/resources/resource/blocklist.resource';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-blocklist-route-page',
  template: `
    <adn-blocklist-list-page
      *ngIf="list"
      [list]="list">
    </adn-blocklist-list-page>
  `
})
export class BlocklistRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(BlocklistResource) private readonly Blocklist: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasAny(PERMISSIONS.managePublishing.apiKey)
      && !this.LocalUserPermissions.hasAny(PERMISSIONS.axPublisher.apiKey);
    this.adnListHelper.setUpList(this.list, this.Blocklist, readOnly, 'fullBlocklistList', {
      baseTable: 'blocklist'
    });
  }
}
